import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=d66b5c8c&scoped=true&"
import script from "./pdfViewer.vue?vue&type=script&lang=js&"
export * from "./pdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./pdfViewer.vue?vue&type=style&index=0&id=d66b5c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66b5c8c",
  null
  
)

export default component.exports